import List from './actions/list';
import Find from './actions/find';
import Create from './actions/create';
import Update from './actions/update';
import Delete from './actions/delete';
import History from './actions/history';
import Resource from './resource';
import Page from './page';

export type RequestObject = {
  method: string,
  path: any,
  body?: {
    record: {
      // eslint-disable-next-line camelcase
      changeset_id: any;
    };
  },
};
export default class Record extends Resource {
  get resourceName() {
    return 'record';
  }

  get resourcesName() {
    return 'records';
  }

  delete(id, changesetID, callback?, extraOptions = {}) {
    const options: RequestObject = {
      ...extraOptions,
      method: 'DELETE',
      path: this.member(id),
    };

    if (changesetID != null) {
      options.body = {
        record: {
          changeset_id: changesetID,
        },
      };
    }
    // @ts-ignore
    return this.call(options, callback);
  }

  async query(params) {
    const options = {
      method: 'POST',
      path: 'records/lookup',
      body: params,
    };

    const body = await this.call(options);

    return new Page(JSON.parse(body), this.resourcesName);
  }
}
// @ts-ignore
List.includeInto(Record);
// @ts-ignore
Find.includeInto(Record);
// @ts-ignore
Create.includeInto(Record);
// @ts-ignore
Update.includeInto(Record);
// @ts-ignore
Delete.includeInto(Record);
// @ts-ignore
History.includeInto(Record);
